import React, { Suspense, useEffect, useState } from "react";
import {
  HashRouter,
  Switch,
  Route,
  Redirect,
  useLocation,
} from "react-router-dom";

// HOOKS
import { useQlik } from "../context/Qlik";
import { useFilterBar } from "../context/FilterBar";
import { useLeftBar } from "../context/LeftBar";
import { useConfig } from "../context/Config";

// PAGES
import OnePage from "./OnePage/OnePage";
import Investments from "./Investments/Investments";
import Opportunity from "./Opportunity/Opportunity";
import Detail from "./Performance/Detail/Detail";
import General from "./Performance/General/General";

// COMPONENTS
import LeftSideMenu from "../components/LeftSideMenu/LeftSideMenu";
import AppLoader from "../components/AppLoader/AppLoader";
import FilterMenu from "../components/FilterMenuNative/FilterMenu";
import Header from "../components/Header/Header";

// ASSETS
// import logo from '../assets/logo.png';
import logo from "../assets/icons/logo.png";
import "../style.scss";
import { I18nextProvider } from "react-i18next";
import i18n from "../i18n";
import MiddlewareRoute from "../components/MiddlewareRoute";
import Auth from "./auth";
import Logout from "./auth/Logout";

function LayoutPage() {
  const { qlik, qlikConfig, setActualApp } = useQlik();
  const { filterBarOpened } = useFilterBar();
  const { leftBarOpened } = useLeftBar();
  const { config } = useConfig();
  const [app, setApp] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (qlik) {
      setIsLoading(false);
      const qvfId = process.env.REACT_APP_QVF_ID;
      const tempApp = qlik.openApp(qvfId, qlikConfig);
      window.app = tempApp;
      setApp(tempApp);
      setActualApp(tempApp);
    }
  }, [qlik, qlikConfig, setActualApp]);

  useEffect(() => {
    if (qlik) setTimeout(qlik.resize, 500);
  }, [filterBarOpened, leftBarOpened, qlik]);

  return isLoading ? (
    <AppLoader />
  ) : (
    <div
      style={{ left: leftBarOpened && "224px" }}
      className={filterBarOpened ? "appWrapper is-right-opened" : "appWrapper"}
    >
      <div id="expandedWrapper" />
      <HashRouter>
        <LeftSideMenu app={app} config={config} logo={logo} />
        <Header />
        <FilterMenu app={app} filters={config.app?.filters || {}} />
        <Switch>
          <Route exact path="/">
            <Redirect to="/one-page" />
          </Route>
          <Route path="/auth" render={() => <Auth />} />
          <Route path="/redirect" render={() => <Logout />} />
          <Route
            path="/logout"
            render={() => <MiddlewareRoute component={<Logout />} publico />}
          />
          <Route
            path="/one-page"
            exact
            render={() => (
              <MiddlewareRoute
                component={<OnePage app={app} config={config} />}
                container
              />
            )}
          />
          <Route
            path="/investments"
            exact
            render={() => (
              <MiddlewareRoute
                component={<Investments app={app} config={config} />}
                container
              />
            )}
          />
          <Route
            path="/opportunity/coverage-5-of-6"
            exact
            render={() => (
              <MiddlewareRoute
                component={
                  <Opportunity
                    app={app}
                    config={config}
                    filter="Cobertura Qualificada"
                  />
                }
                container
              />
            )}
          />
          <Route
            path="/opportunity/inovation"
            exact
            render={() => (
              <MiddlewareRoute
                component={
                  <Opportunity app={app} config={config} filter="Inovação" />
                }
                container
              />
            )}
          />
          <Route
            path="/opportunity/opportunity"
            exact
            render={() => (
              <MiddlewareRoute
                component={
                  <Opportunity
                    app={app}
                    config={config}
                    filter="Oportunidades"
                  />
                }
                container
              />
            )}
          />
          <Route
            path="/opportunity/combos"
            exact
            render={() => (
              <MiddlewareRoute
                component={
                  <Opportunity
                    app={app}
                    config={config}
                    filter="Combos"
                  />
                }
                container
              />
            )}
          />
          <Route
            path="/performance/general"
            exact
            render={() => (
              <MiddlewareRoute
                component={<Detail app={app} config={config} />}
                container
              />
            )}
          />
          <Route
            path="/performance/sellout"
            exact
            render={() => (
              <MiddlewareRoute
                component={
                  <General app={app} config={config} filter="Sell Out" />
                }
                container
              />
            )}
          />
          <Route
            path="/performance/coverage-total"
            exact
            render={() => (
              <MiddlewareRoute
                component={
                  <General app={app} config={config} filter="Cobertura Total" />
                }
                container
              />
            )}
          />
          <Route
            path="/performance/coverage-5-of-6"
            exact
            render={() => (
              <MiddlewareRoute
                component={
                  <General
                    app={app}
                    config={config}
                    filter="Cobertura Qualificada"
                  />
                }
                container
              />
            )}
          />
        </Switch>
      </HashRouter>
    </div>
  );
}

export default function Layout() {
  return (
    <Suspense fallback={<AppLoader />}>
      <I18nextProvider i18n={i18n}>
        <LayoutPage />
      </I18nextProvider>
    </Suspense>
  );
}
